import React, { useEffect, useMemo, useState } from "react";
import { Link, Typography } from "@mui/material";
import type { Selected } from "../Context";

type TrainPlateProps = {
  train: {
    lineId: string;
    routeId: string;
    active: boolean;
    lastUpdate: Date | null;
  };
  selected: Selected | null;
  setSelected: (sel: Selected | null) => void;
};

export const TrainPlate = ({ train, selected, setSelected }: TrainPlateProps) => {
  const blinkTime = 30000;

  const baseColor = useMemo(() => (train.active ? "#ffff54" : "#ffffff"), [train.active]);

  const [color, setColor] = useState(baseColor);
  const [bold, setBold] = useState<"normal" | "bold">("normal");

  useEffect(() => {
    // Blink orange if recently updated
    const eventTime = train.lastUpdate ?? new Date(0);
    const diff = Date.now() - eventTime.getTime();

    if (diff < blinkTime) {
      setColor("#FFA500");
      setBold("bold");
    } else {
      setColor(baseColor);
      setBold("normal");
    }

    const remaining = Math.max(0, blinkTime - diff);
    const t = window.setTimeout(() => {
      setColor(baseColor);
      setBold("normal");
    }, remaining);

    return () => window.clearTimeout(t);
  }, [train.lastUpdate, baseColor]);

  const isSelected =
    selected?.lineId === train.lineId && selected?.routeId === train.routeId;

  return (
    <Typography
      textAlign="center"
      fontWeight={bold}
      sx={{
        fontSize: "12px",
        padding: "13px",
        color: "#ffffff",
        ...(isSelected ? { background: "#163244" } : {}),
      }}
      noWrap
    >
      <Link
        color={color}
        underline="none"
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setSelected({ lineId: train.lineId, routeId: train.routeId });
        }}
      >
        {train.routeId}
      </Link>
    </Typography>
  );
};